import Head from 'next/head';
import Hero from '@components/containers/home/Hero';
import HomeCards from '@components/containers/home/HomeCards';
import FeaturesList from '@components/containers/home/FeaturesList';
import Leverage from '@components/containers/home/Leverage';
import Liquidity from '@components/containers/home/Liquidity';
import { GradientWrapper } from './home.styles';
import Container from '@components/common/Container';
import Banner from '@components/common/Banner';

export default function Home() {
  return (
    <>
      <Head>
        <title>ArchimedesFi</title>
        <meta name="description" content="Up to 10X leverage on leading meta-vaults, tokenized as NFTs" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <GradientWrapper>
        {/* <Banner /> */}
        <Container>
          <Hero />
          <HomeCards />
          <FeaturesList />
        </Container>
      </GradientWrapper>
      <Leverage />
      <Liquidity />
    </>
  );
}
